import CssBaseline from '@mui/material/CssBaseline';
import React from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { AuthProvider } from './context/AuthContext';
import { SnackbarProviderWrapper } from './context/SnackbarContext';
import { ThemeProvider } from './context/ThemeContext';
import { WebSocketProvider } from './context/WebSocketContext';

import { Navigation } from './navigation';

import ErrorFallback from './share/ErrorFallback';
import ErrorHandlerProvider from './components/ErrorHandlerProvider';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SnackbarProviderWrapper>
          <ErrorHandlerProvider>
            <AuthProvider>
              <WebSocketProvider>
                <BrowserRouter>
                  <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <Navigation />
                  </ErrorBoundary>
                </BrowserRouter>
              </WebSocketProvider>
            </AuthProvider>
          </ErrorHandlerProvider>
        </SnackbarProviderWrapper>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
